var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce0000",
    fillRule: "evenodd",
    d: "M27.3 0H54v40H27.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.7 0h26.6v40H.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1eeee",
    fillRule: "evenodd",
    d: "M13.6 11.8q0 .2-.3.2t-.2-.2.2-.2.3.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    fillRule: "evenodd",
    d: "M5 10.9v5h5c0 .8.9 1.6 1.7 1.6v5h5v-5c.8 0 1.6-.8 1.6-1.7h5v-5h-5c0-.7-.8-1.6-1.7-1.6v-5h-5v5c-.8 0-1.6.9-1.6 1.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe600",
    fillRule: "evenodd",
    d: "M5.2 11v4.7h5c0 .8.8 1.6 1.6 1.6v5h4.7v-5c.8 0 1.6-.8 1.6-1.6h5v-4.6h-5q-.2-1.5-1.6-1.7v-5h-4.7v5c-.8 0-1.6.8-1.6 1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M5.4 11.2v4.3h5c0 .8.8 1.7 1.6 1.7v5h4.3v-5c.8 0 1.7-.9 1.7-1.7h5v-4.3h-5c0-.8-.9-1.6-1.7-1.6v-5H12v5c-.8 0-1.7.8-1.7 1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    fillRule: "evenodd",
    d: "M5.6 11.4v4h5q.1 1.4 1.6 1.6v5h4v-5c.8 0 1.6-.8 1.6-1.7h5v-4h-5Q17.6 10 16 9.8v-5h-4v5c-.8 0-1.6.9-1.6 1.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M12.2 9.3q.3.6-.5 1.6-1 1-1.6.5-.3-.6.5-1.6 1-1 1.6-.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M11.8 9.7q.5.5-.1 1.2-.8.6-1.2.2-.5-.6.1-1.3.8-.5 1.2-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "m10.4 10.5.5.2-.3-.5.2-.1.4 1zm.7-.7.7.6-.1.1zm7.1 1.6q-.6.4-1.6-.5t-.5-1.6q.6-.4 1.6.5t.5 1.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M17.8 11q-.4.6-1.2-.1-.6-.7-.2-1.2.6-.4 1.3.1.6.7.1 1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "m17 9.6-.2.5.5-.2h.1l-.9.5zm.7.7-.6.7H17zM16 17.4q-.3-.6.6-1.6 1-1 1.6-.5.4.6-.5 1.6t-1.6.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M16.4 17q-.3-.4.2-1.2.8-.6 1.2-.1.5.5-.1 1.2-.7.5-1.3.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "m17.9 16.2-.1.1-.5-.2.3.4-.2.1-.4-.9zm-.7.7-.1.1-.7-.7.1-.1zm-7.1-1.6q.6-.3 1.6.5.8 1 .5 1.6-.6.3-1.6-.5-1-1-.5-1.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M10.5 15.7q.5-.5 1.2.1t.1 1.3q-.4.3-1.2-.2-.6-.7-.1-1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M11.3 17.1V17l.1-.5-.4.3-.1-.2.9-.4zm-.7-.7.6-.7.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#707070",
    strokeWidth: 0.1,
    d: "M17.6 13.4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#707070",
    strokeWidth: 0.1,
    d: "M16.8 13.4a2.6 2.6 0 1 1-5.3 0 2.6 2.6 0 0 1 5.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M13 16.2a.2.2 0 1 1-.3 0zm2.6 0a.2.2 0 1 1-.3 0zm-1.6 0v.2h-.2q-.3 0 0 .1h.2v.2q.1.3.2 0v-.2h.3q.3 0 0-.1h-.2v-.2q-.1-.3-.3 0m-.7-2.5-.4.1h-.3v.9h-.2l.1-.4-.2-.6zm1.3-.3h.9l.1.4v.2q-.1 0 0-.2l-.2-.3H15c-.4 0-.2-.1-.3-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M14.7 13.6h.6l.1.5-.1.2v-.5h-.9l-.6.1-.8-.1h-.8v1-.4l-.2-.6h.3l-.1-.7q0-.3.6-.2h1.3c.2 0 0-.5.3-.7l.4-.2.3.5H15v.1q-.2 0-.3-.2l.1.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "m13.7 13.2-.5.4.1.2-.3-.3.4-.3-.3-.3v-.6l-.6-.3.5-.5h.1l-.4.5h.6l-.2-.2.2-.1.2.1-.1.2h.2l.5.4v.1l-.5-.2v.9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7a7a7",
    fillRule: "evenodd",
    d: "M13 12h.7v.8H13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M15.1 14.5 13 11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M13.2 11.5H13v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "m15 12.4-.5.1H14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7a7a7",
    fillRule: "evenodd",
    d: "M13 12.8h.6v.2H13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "m15 12.5-.2.1zm-.1-.1v.2zm0 .4H14h.7m-1.3 0H13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M12.4 14.5q-.1.1.5.2.5 0 .3-.2h-.4q0 .2-.1.1-.2-.2 0-.3h1q-.1.3 0 .4H15v-.3l-.4-.1-.1-.1h.1V14h-.1l.2.1h.4v.1q.2.2.2.5l-.2.3h.7l.2.2h-.7l-.6-.2h-.9l-.6.2H13l.2-.1.4-.2v-.5h-.8v.2-.2h.3l.3.1v.2h-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M16.9 13.5h.2l.4-.2v.2h-.3v.2l.1.2v.2l-.2-.4h-.2zm-.4-1.5.4-.2v-.3l.2.6-.1-.2zm-.6-.8.4-.4v.7l.3-.3.1.1-.4.4V11zm-1.7-.7.1-.5h.1v.5h.3zm-.8.1v-.5zh.4zm-1.5.7.2-.2.2.1-.1.2-.2.1-.1.1h-.3v-.4l.1-.1.1-.1h.2-.2v.1l-.1.1v.3h.2l.3-.2-.1-.1zm0 3.7-.4.3-.3-.4.3.3.1-.1-.2-.3.2.3zm-.6-.6.1-.2V14l-.1-.1H11v.2l.1.2zm0 0h-.2l-.2-.2v-.4h.5v.6m0-1h-.5V13l.1-.1h.2v.2l.1-.2h.2l-.2.1zm-.2-.1v-.4H11l-.1.1v.3zm1.4-2.3v-.6h.1l.5.2v.1H13l-.3.1zm0-.3h.3l-.1-.2h-.1zm2.6-.1.5-.2h.1v.6h-.1v-.2l-.3-.2zm.3 0 .2.1v-.3zm1.4 1.9.5-.2v.7h-.1l-.1-.2v.2l-.2.2v-.3h.1v-.4zm.3 0v.3l.1.1q.2-.1 0-.2v-.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.9019382ebfa3dfc4b14a0455a9333724.svg";
export { ForwardRef as ReactComponent };